import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "./components/ui/sonner";
import { AuthProvider } from "./lib/auth";
import Protected from "./components/Protected";
import Landing from "./pages/Landing";
import Login from "./pages/Login";
import Register from "./pages/Register";
import Dashboard from "./pages/Dashboard";
import WalletPage from "./pages/WalletPage";
import Tree from "./pages/Tree";
import Pairing from "./pages/Pairing";
import AddMember from "./pages/AddMember";
import KYCPage from "./pages/KYCPage";
import AdminHome from "./pages/AdminHome";
import AdminUsers from "./pages/AdminUsers";
import AdminPairing from "./pages/AdminPairing";
import AdminKYC from "./pages/AdminKYC";
import AdminSettings from "./pages/AdminSettings";
import AdminBusinessIncome from "./pages/AdminBusinessIncome";
import AdminMemberEarnings from "./pages/AdminMemberEarnings";
import AdminReports from "./pages/AdminReports";
import AdminNetworkTree from "./pages/AdminNetworkTree";
import Team from "./pages/Team";
import "./App.css";

function App() {
    return (
        <AuthProvider>
            <BrowserRouter>
                <Routes>
                    {/* Public */}
                    <Route path="/" element={<Landing />} />
                    <Route path="/login" element={<Login />} />
                    <Route path="/register" element={<Register />} />

                    {/* Member — protected */}
                    <Route path="/app/dashboard" element={<Protected><Dashboard /></Protected>} />
                    <Route path="/app/add-member" element={<Protected><AddMember /></Protected>} />
                    <Route path="/app/kyc" element={<Protected><KYCPage /></Protected>} />
                    <Route path="/kyc/digilocker/callback" element={<Protected><KYCPage /></Protected>} />
                    <Route path="/app/wallet" element={<Protected><WalletPage /></Protected>} />
                    <Route path="/app/tree" element={<Protected><Tree /></Protected>} />
                    <Route path="/app/team" element={<Protected><Team /></Protected>} />
                    <Route path="/app/pairing" element={<Protected><Pairing /></Protected>} />

                    {/* Admin — protected + role check */}
                    <Route path="/admin" element={<Protected admin><AdminHome /></Protected>} />
                    <Route path="/admin/users" element={<Protected admin><AdminUsers /></Protected>} />
                    <Route path="/admin/pairing" element={<Protected admin><AdminPairing /></Protected>} />
                    <Route path="/admin/kyc" element={<Protected admin><AdminKYC /></Protected>} />
                    <Route path="/admin/settings" element={<Protected admin><AdminSettings /></Protected>} />
                    <Route path="/admin/business-income" element={<Protected admin><AdminBusinessIncome /></Protected>} />
                    <Route path="/admin/member-earnings" element={<Protected admin><AdminMemberEarnings /></Protected>} />
                    <Route path="/admin/reports" element={<Protected admin><AdminReports /></Protected>} />
                    <Route path="/admin/network-tree" element={<Protected admin><AdminNetworkTree /></Protected>} />
                </Routes>
            </BrowserRouter>
            <Toaster position="top-right" richColors />
        </AuthProvider>
    );
}

export default App;
